import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ActivateInactivatePersonProfileUseCaseInterface } from 'domain/usecases';

export class RemoteActivateInactivatePersonProfile
  implements ActivateInactivatePersonProfileUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: ActivateInactivatePersonProfileUseCaseInterface.Params,
  ): Promise<ActivateInactivatePersonProfileUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.activeStatus}/${params.id}`,
      method: 'patch',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
